import { Outlet } from "react-router-dom";
import Topbar from "@/components/shared/Topbar";
import Bottombar from "@/components/shared/Bottombar";
import LeftSidebar from "@/components/shared/LeftSidebar";
import { useState } from "react";
import { useScrollDirection } from "@/hooks/useScrollDirection";

const RootLayout = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const scrollDir = useScrollDirection();

  return (
    <div className="flex flex-col min-h-[100dvh] bg-dark-1 text-white">
      {/* Topbar (fixed) */}
      <Topbar scrollDir={scrollDir} />

      {/* Main area: sidebar + content */}
      <div className="flex flex-1">
        {/* Sidebar (only on md+) */}
        <div className="hidden md:block w-72 bg-gray-800 overflow-y-auto h-[calc(130dvh-56px)] scrollbar-hide">
          <LeftSidebar />
        </div>

        {/* Main content (scrollable area with bottom padding) */}
        <section className="flex-1 overflow-auto pb-[calc(70px+env(safe-area-inset-bottom))] scrollbar-hide">
          <Outlet context={{ selectedCategory, setSelectedCategory }} />
        </section>
      </div>

      {/* BottomBar (sticky on mobile, safe-area-aware) */}
      <div className="sticky bottom-0 w-full z-50 bg-dark-2 rounded-t-[20px] transition-transform duration-300 pb-[env(safe-area-inset-bottom)]">
        <Bottombar scrollDir={scrollDir} />
      </div>
    </div>
  );
};

export default RootLayout;
